import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { AppContent, AppFooter, AppHeader } from '../components/index'
import {ToastContainer, Zoom} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {CContainer, CImage, CLink} from "@coreui/react";
import KakaoBtn from "../assets/img/btn_kakaotalk.svg";
import {useMatch} from "react-router-dom";

const DefaultLayout = () => {
  const isMain = useMatch('/home');
  const isTiles = useMatch('/tiles');
  const isDetail = useMatch('/detail/:id');

  const rootClass = isMain ? 'main' : (isTiles ? 'tile' : (isDetail ? 'detail' : ''));
  const dispatch = useDispatch();

  useEffect( () => {
    resize();
    window.addEventListener("resize", resize);
    return () => {
      window.removeEventListener("resize", resize);
    }
  }, []);
  
  const resize = () => {
    if(window.innerWidth <= 1160) {  // mobile
      dispatch({ type: 'updateIsMobile', isMobile: true });
    }
    else {
      dispatch({ type: 'updateIsMobile', isMobile: false });
    }
  }

  return (
    <div className={rootClass}>
      <div className="wrapper d-flex flex-column min-vh-100">
        <AppHeader />
        <div className="body flex-grow-1">
          <AppContent />
        </div>
        <CContainer className="kakao-contact-box" fluid>
          <div className="kakao-contact">
            <CLink href="https://pf.kakao.com/_WxfxgUxj" target="_blank"><CImage src={KakaoBtn} width={100} height={40} alt="카카오톡 문의" /></CLink>
          </div>
        </CContainer>
        <AppFooter/>
      </div>
      <ToastContainer position="bottom-center"
                      autoClose={3000}
                      hideProgressBar={true}
                      closeButton={false}
                      transition={Zoom}
                      pauseOnHover={false}
                      pauseOnFocusLoss={false}
                      closeOnClick={true}
                      draggable={false}
      />
    </div>
  )
}

export default DefaultLayout
